import { createFeature } from '@ngrx/store';
import { collectionsReducer } from './collections-reducer';

export const collectionsFeature = createFeature({
  name: 'collection',
  reducer: collectionsReducer,
});
